// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".provider-contact[data-v-02a041ba]{display:flex}.circle-button[data-v-02a041ba]{border-radius:50%;width:32px;height:32px;margin-right:8px;display:flex;align-items:center;justify-content:center;background-color:var(--primary-color)}.circle-button[data-v-02a041ba]:hover{background-color:var(--secondary-color)}", ""]);
// Exports
module.exports = exports;
